<template>
  <div class="container page" style="background: #f4f4f4;">
    <van-nav-bar :title="$t('wallet.bind_title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-box">
      <van-cell-group>
        <div class="c_p_j">
          <span>*</span>{{$t('wallet.account_name')}}
        </div>
        <van-field v-model="username" readonly :placeholder="$t('setting.username_place')" />
        <div class="c_p_j">
          {{$t('wallet.wallet_type')}}（{{$t('wallet.optional')}}）
        </div>
        <van-field v-model="walletType" :placeholder="$t('wallet.type_placeholder')" />
        <div class="c_p_j">
          <span>*</span>{{$t('wallet.wallet_address')}}
        </div>
        <van-field v-model="walletAddress" :placeholder="$t('wallet.address_placeholder')" />
        <div class="c_p_j">
          <span>*</span>{{$t('wallet.confirm_wallet_address')}}
        </div>
        <van-field v-model="confirmAddress" :placeholder="$t('wallet.confirm_address_placeholder')" />
        <div class="c_p_j">
          <span>*</span>{{$t('wallet.fund_password')}}
        </div>
        <!-- 交易密码（提现密码）输入字段 -->
        <van-field
          v-model="withdrawPassword"
          type="password"
          :placeholder="$t('wallet.password_placeholder')"
        />

      </van-cell-group>
      <p>{{$t('wallet.bind_warn')}}</p>
    </div>

    <div
      class="sub-btn"
      :class="{ disabled: submitted }"
      @click="!submitted && bindWallet()"
    >
      {{$t('wallet.submit')}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      username: "",          // 账户姓名（来自 user_info 的 name）
      walletType: "",        // 钱包类型（自由填写，如 USDT-TRC20 / USDT-ERC20 / BTC）
      walletAddress: "",     // 钱包地址
      confirmAddress: "",    // 确认钱包地址
      // 交易密码（提现密码）
      withdrawPassword: "",
      submitted: false // 是否已提交
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindWallet(){
      // 只校验钱包地址：地址填了就能绑，不限制 USDT / ERC20 等任何链或类型
      if(this.walletAddress === "" || this.walletAddress === null || this.walletAddress === undefined){
        this.$toast.fail(this.$t('wallet.err_address_required'));
        return false;
      }
      if(this.walletAddress !== this.confirmAddress){
        this.$toast.fail(this.$t('wallet.err_address_mismatch'));
        return false;
      }
      if(this.withdrawPassword === ""){
        this.$toast.fail(this.$t('wallet.err_password_required'));
        return false;
      }

      this.$http({
        method: 'post',
        url: 'user_set_bank',
        data:{
          bankid: this.walletAddress,                            // 钱包地址
          bank: this.walletType || 'Wallet',                     // 钱包类型（选填）
          username: this.username,                               // 账户姓名
          bankfenhang: this.walletType || 'Wallet',              // 钱包类型（选填）
          withdraw_password: this.withdrawPassword               // 交易密码
        }
      }).then(res=>{
        if(res.code === 200){
          // 提交成功，禁用表单和按钮
          this.submitted = true;
          this.$toast(res.msg);
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.username = res.data.name;
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.c_p_j{
  padding: 26px 30px;
  color: #000;
  font-size: 26px;
  display: flex;
  align-items: center;
  position: relative;
  span{
    color: red;
    margin-right: 8px;
  }
}
.sub-btn{
  background: rgb(172, 98, 204);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;

  &.disabled {
    background: #999;
    color: #ccc;
    cursor: not-allowed;
  }
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: #fff;
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 4px solid #cfc1c1;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  /deep/ .van-field__control{
    color: #333;
  }
  &:after{
    display: none;
  }
}

.main-box .label{
  padding: 20px 0 20px 26px;
  font-size: 35px;
  color: #f3c7a2;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #f3c7a2;
}
</style>
